"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get CalendarEventOptionalSchema () {
        return CalendarEventOptionalSchema;
    },
    get CalendarEventSchema () {
        return CalendarEventSchema;
    }
});
const _zod = require("zod");
const CalendarEventSchema = _zod.z.object({
    /**
	 * The external calendar event ID from the provider (Google, Outlook, etc.)
	 */ event_id: _zod.z.string(),
    /**
	 * The calendar provider that hosts this event
	 */ provider: _zod.z.enum([
        "google",
        "outlook"
    ]),
    /**
	 * The calendar ID within the provider where this event is stored
	 */ calendar_id: _zod.z.string(),
    /**
	 * When this calendar event record was first created
	 */ created: _zod.z.instanceof(Date),
    /**
	 * When this calendar event record was last updated
	 */ updated: _zod.z.instanceof(Date)
});
const CalendarEventOptionalSchema = CalendarEventSchema.optional();
